module.exports = __webpack_public_path__ + "img/1576894749.cb641b2f.jpg";